import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit ground tile: a 1x1 m slab exactly 0.06 thick (top at y = 0.06),
// centred on the origin, seating seamlessly against every other ground tile.
const CONCRETE = "#9a9a94";
const JOINT = "#8a8a84";

export const drivewayTile = defineModel({
  id: "driveway-tile",
  batchId: "modern",
  name: "Driveway tile",
  tags: ["modern", "outdoor", "ground", "street", "driveway", "concrete"],
  summary: "A concrete driveway tile with expansion joints along Z.",
  description:
    "A one-tile concrete driveway of the Modern Living kit: a 1x1 m slab " +
    "(0.06 m thick) with two thin flush expansion-joint lines running along " +
    "Z, so chained tiles form a continuous jointed drive. Tiles seamlessly " +
    "with every other ground piece.",
  tiles: { w: 1, h: 1 },
  footprint: 0.75,
  parts(): Part[] {
    return [
      { geometry: new THREE.BoxGeometry(1.0, 0.06, 1.0), color: CONCRETE, position: [0, 0.03, 0] },
      {
        geometry: new THREE.BoxGeometry(0.03, 0.012, 1.0),
        color: JOINT,
        position: [-0.25, 0.06, 0],
      },
      {
        geometry: new THREE.BoxGeometry(0.03, 0.012, 1.0),
        color: JOINT,
        position: [0.25, 0.06, 0],
      },
    ];
  },
  animations: [],
});
